import { useState } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function NewsletterSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return;

    setStatus('submitting');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d7t25d4dj3knvn2p36qg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }

    setTimeout(() => setStatus('idle'), 4000);
  };

  return (
    <section ref={ref} className="w-full bg-brand-black py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="max-w-2xl mx-auto text-center" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Newsletter
          </span>
          <h2 className="font-serif text-white text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            Recibe las
            <span className="italic text-brand-gray-300"> mejores tendencias</span>
          </h2>
          <p className="font-sans text-brand-gray-300 text-base leading-[1.8] mt-5">
            Suscríbete para recibir artículos exclusivos sobre moda, estilo y técnicas
            artesanales directamente en tu bandeja de entrada.
          </p>

          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="mt-10 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
            style={isVisible ? {
              opacity: 1,
              transform: 'translateY(0px)',
              transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms',
            } : {
              opacity: 0,
              transform: 'translateY(24px)',
              transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms',
              willChange: 'opacity, transform',
            }}
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Tu correo electrónico"
              required
              className="flex-1 bg-white/10 border border-white/20 rounded-md px-5 py-3.5 font-sans text-white text-sm placeholder:text-brand-gray-400 focus:outline-none focus:border-white/40 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'submitting'}
              className="bg-white text-brand-black font-sans text-[13px] tracking-widest uppercase px-7 py-3.5 rounded-md hover:bg-brand-gray-50 transition-colors duration-300 whitespace-nowrap disabled:opacity-60"
            >
              {status === 'submitting' ? 'Enviando...' : 'Suscribirme'}
            </button>
          </form>

          {status === 'success' && (
            <p className="font-sans text-emerald-400 text-sm mt-4">
              ¡Gracias por suscribirte! Pronto recibirás nuestros artículos.
            </p>
          )}
          {status === 'error' && (
            <p className="font-sans text-red-400 text-sm mt-4">
              Ha ocurrido un error. Por favor, inténtalo de nuevo.
            </p>
          )}

          <p className="font-sans text-brand-gray-500 text-xs mt-5">
            Puedes darte de baja en cualquier momento. Respetamos tu privacidad.
          </p>
        </div>
      </div>
    </section>
  );
}